/**
 * FeaturedArtistList Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import SectionTitle from '../SectionTitle';
import FeaturedArtist from './FeaturedArtist';

interface IOwnProps {
  data: GQL.ITrackSearchResult[];
}

const classes = new BEM('featured-artist-list');

export default function FeaturedArtistList({ data }: IOwnProps) {
  return !!data.length ? (
    <div {...classes()}>
      <div {...classes('content-wrapper', '', 'container')}>
        <SectionTitle title="Artists" subtitle="Featured" {...classes('title') } />
        <ul {...classes('list')}>
          {data.map((track) => (
            <li  {...classes('list__item')} key={`featured-artist-${track.artist!.slug}`}>
              <FeaturedArtist track={track} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/content/FeaturedArtists/index.tsx